import { IKnmListFilterRaw } from 'APIPackage/KnmListModule/interfaces/IKnmListFilterRaw';
import { SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';

import { IKnmListByPlanFilter } from '../interfaces/IKnmListByPlanFilter';

export function mapKnmListByPlanFilterToRaw(data: IKnmListByPlanFilter): IKnmListFilterRaw {
  return {
    name: data.name,
    riskCategory: data.riskCategory?.map(riskCategoryItem => riskCategoryItem.name),
    reasonDateBetween:
      data?.reasonDateBetweenStart || data?.reasonDateBetweenEnd
        ? [
            formatDate({ date: data?.reasonDateBetweenStart || '', dateFormat: SYSTEM_DATE_FORMAT_FNS }),
            formatDate({ date: data?.reasonDateBetweenEnd || '', dateFormat: SYSTEM_DATE_FORMAT_FNS }),
          ]
        : undefined,
    mspCategory: data.mspCategory?.map(mspCategoryItem => mspCategoryItem.title),
    supervisionTypeId: data.supervisionType?.id,
    objectsType: data.objectsType?.title ? [data.objectsType?.title] : undefined,
    objectsKind: data.objectsKind?.title ? [data.objectsKind?.title] : undefined,
    objectsSubKind: data.objectsSubKind?.title ? [data.objectsSubKind?.title] : undefined,
    isHasRequirements: data.isHasRequirements?.value,
    isHasApproveDocs: data.isHasApproveDocs?.value,
    startDateBetween:
      data?.startDateBetweenStart || data?.startDateBetweenEnd
        ? [
            formatDate({ date: data?.startDateBetweenStart || '', dateFormat: SYSTEM_DATE_FORMAT_FNS }),
            formatDate({ date: data?.startDateBetweenEnd || '', dateFormat: SYSTEM_DATE_FORMAT_FNS }),
          ]
        : undefined,
    kinds: data.kinds?.title ? [data.kinds?.title] : undefined,
    events: data.events?.map(event => event.title),
    isHasCollaboratingOrganization: data.isHasApproveDocs?.value,
    signed: data.signed !== undefined ? data.signed : undefined,
  };
}
